import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { Column, ColumnKeys } from './grid-config';
import { StorageProtectionExclusionItem } from '@nirvana/shared/dtos/types/policies/common';
import { sortByColumn } from '../utils/sorters';

export class GzStorageProtectionExclusionsGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  StorageProtectionExclusionItem
> {
  sortByColumnMethod(
    a: StorageProtectionExclusionItem,
    b: StorageProtectionExclusionItem,
    sortColumnName: string,
    sortDirection: string
  ): number {
    return sortByColumn(a, b, sortColumnName, sortDirection);
  }
}
